import React from 'react';
import { SvgIconProps } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ContrastIcon from '@mui/icons-material/Contrast';
import { ReadStatus } from '../types';

// The read toggle's icon: an open eye when read, a half-filled circle when
// started, an outlined eye otherwise
const ReadStateIcon = ({ status, ...props }: SvgIconProps & { status: ReadStatus }) => {
  if (status === 'read') return <VisibilityIcon {...props} />;
  if (status === 'started') return <ContrastIcon {...props} />;
  return <VisibilityOutlinedIcon {...props} />;
};

export default ReadStateIcon;
